export const normalizeEmails = (value: string): string => {
  if (!value?.trim()) return "";
  return value
    .split(/[,;\s\n\r]+/)
    .map((e) => e.trim())
    .filter((e) => e.length > 0)
    .join("; ");
};
